export * from './proof-of-identity.form';
export * from './personal-details.form';
export * from './nationalities.form';
export * from './identity-details.form';
export * from './tax-details.form';
export * from './addresses.form';
export * from './contact-details.form';
export * from './change-client-status.form';
export * from './purpose-of-trading.form';
export * from './source-of-funds.form';
export * from './source-of-incomes.form';
export * from './pep-details.form';
export * from './estimated-worth.form';
export * from './localized-details.form';
export * from './bank-accounts.form';
export * from './proof-of-address.form';
export * from './uploaded-documents.form';
export * from './add-document.form';
export * from './other-documents.form';
export * from './financial-sanctions.form';
export * from './individual-registration.form';
export * from './company/company-registration.form';
export * from './add-user-to-client.form';
export * from './compliance-risk.form';
export * from './trade-settings.form';
export * from './disable-accounts.form';
export * from './user-details.form';

export * from './company/company.form';
export * from './company/company-tax-details.form';
export * from './company/company-vat-details.form';
